module.exports = __webpack_public_path__ + "img/3066439-94-6.64a399fc.png";